// A click anywhere outside the new-comment box folds it (TicketConversation's handleClickOutside), except on the
// controls an agent uses while writing. Matched on what the click is INSIDE, not the element under the pointer: a
// dropdown's text and chevron are a span and a div within its button, so matching the exact element let those clicks
// through and folded the box. The ticket's properties panel is left alone entirely, empty space included.
const KEEPS_COMPOSER_OPEN = [
  'button',
  '.ui-dropdown',
  '[role="listbox"]',
  '[role="option"]',
  '.ui-popup__content',
  '.ticket-properties-panel',
].join(',');

export const keepsComposerOpen = (target: EventTarget | null): boolean =>
  target instanceof Element && target.closest(KEEPS_COMPOSER_OPEN) != null;
